module.exports = __webpack_public_path__ + "1c5527b19caa80ac739a68dc830092ff.png";